import { SubdomainsComponent } from '../components';

export default SubdomainsComponent;
